
<template>
  <v-container class="pa-8">
    <v-data-table
      :headers="headers"
      :items="users"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title> Utenti </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="mx-5"
            append-icon="mdi-magnify"
            label="Search User"
            single-line
            hide-details
          ></v-text-field>

          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nuovo Utente
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-card-text>
                      <v-container>
                        <v-text-field
                          label="Username"
                          type="text"
                          v-model="editedUser.username" :readonly="editedUser.idRuolo==1"
                        ></v-text-field>

                        <v-text-field
                          label="Password"
                          type="password"
                          v-if="editedUser.idRuolo!=1"
                          v-model="editedUser.password"
                        ></v-text-field>

                        <v-select
                          :items="roles"
                          label="Ruolo"
                          item-text="description"
                          item-value="id"
                          v-if="editedUser.idRuolo!=1"
                          v-model="editedUser.idRuolo"
                        >
                        </v-select>
                        <v-select
                          :items="operators"
                          label="Operatore associato"
                          item-text="descrizione"
  clearable
                          item-value="idRisorsa" 
                          v-if="editedUser.idRuolo!=1" 
                          v-model="editedUser.idOperatore"
                        >
                        <option>Seleziona un operatore</option>
                        </v-select>
                        <v-row>
                          <v-col>
                            <v-icon>mdi-format-color-fill</v-icon> Colore in
                            calendario:
                            <v-menu
                              ref="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  v-bind:style="{
                                    display: 'inline-block',
                                    width: '30px !important',
                                    'min-width': '0 !important',
                                    height: '30px',
                                    'border-radius': '30px',
                                    'background-color': userColor,
                                  }"
                                >
                                </v-btn>
                                <!-- <v-btn v-bind="attrs" v-on="on" v-if="color==null">
                                  Seleziona colore 
                                </v-btn> 
                                <v-btn v-bind="attrs" v-on="on" v-if="color!=null">
                                  {{color}}
                                </v-btn> -->
                              </template>
                              <v-color-picker
                                class="ma-2"
                                elevation="3"
                                v-model="userColor"
                                hide-canvas
                                hide-inputs
                                hide-mode-switch
                                hide-sliders
                                mode="rgba"
                                show-swatches
                                swatches-max-height="200px"
                              ></v-color-picker>
                              <!-- <v-spacer></v-spacer> -->
                              <!-- <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn> -->
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title class="headline"
                >Sei sicuro di voler rimuovere questo utente?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.colore="{ item }">
        <div
          class="text-center"
          v-bind:style="{
            'background-color': item.colore,
          }"
        >
          <v-col cols="12" md="3">
            <div class="pa-1 rounded-0"></div>
          </v-col>
          <!-- <span class="white--text">{{ item.colore }}</span> -->
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
        <v-icon small @click="deleteItem(item)" :disabled="item.idRuolo==1"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <div>
      <!-- <template>
        <v-btn color="error" class="mt-3" :to="{ name: 'dashboard' }">
          Indietro
        </v-btn>
      </template> -->
    </div>
    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style>
.table-footer-prepend {
  margin-top: -58px;
  height: 58px;
}
</style>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import SessionHelper from '../../utils/SessionHelper';
export default {
  data: () => ({
    dialog: false,
    loading:false,
    operators:[],
    userTest: "#689F38FF",
    styleCell: {
      color: "red",
      fontSize: "13px",
    },
    dialogDelete: false,
    passwordIcon: "mdi-lock",
    passwordFieldType: "password",
    search: "",
    users: [],
    roles: [],
    error: "",

    headers: [
      { text: "Colore", value: "colore", width: "90px" },
      { text: "Username", value: "username" },
      { text: "Ruolo", value: "ruolo.description" },

      { text: "Actions", value: "actions", sortable: false, width: "80px" },
    ],

    editedIndex: -1,
    editedUser: {
      username: "",
      idRuolo: "",
      password: "",
      colore: "transparent",
    },
    defaultItem: {
      username: "",
      idRuolo: "",

      password: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
    userColor: {
      get() {
        console.debug(this.editedUser.colore);
        if (
          this.editedUser.colore != null &&
          this.editedUser.colore != undefined
        )
          return this.editedUser.colore;
        else return "transparent";
      },
      set(value) {
        this.editedUser.colore = value;
        
        console.debug(value);
      },
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize(); 
  },

  methods: {
    loadWorkers() {
      this.loading=true;
      console.log("loading workers...");
      EasyPlanClient.Resources.GetAllOperators(this.$route.params.companyAlias,false)
        .then((res) => {
          this.operators = res.data.data;
          console.log(this.operators);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(()=>{
          this.loading=false;
        });
    },
    editItem(item) {
      console.log(item, "edit user");
      this.editedIndex = this.users.indexOf(item);
      this.editedUser = Object.assign({}, item);
      // if(this.editedUser.idOperatore!=null){

      //  EasyPlanClient.Resources.Find(this.$route.params.companyAlias,
      // this.editedUser.op
      //  )
      // }
      this.dialog = true;
    },

    deleteItem(item) {
      console.debug("delete",item);
      this.editedIndex = this.users.indexOf(item);
      this.editedUser = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
       EasyPlanClient.User.Delete(this.$route.params.companyAlias,
         this.editedUser.idUtente).then((res)=>{

          this.users.splice(this.editedIndex, 1);
          this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    insertUser(user) {
      console.log("insert", user);
      EasyPlanClient.User.Insert(
        this.$route.params.companyAlias,
        user.username,
        user.password,
        user.idRuolo,
        user.colore
      )
        .then((res) => {
          console.debug("risposta add user:");
          console.debug(res);
          this.users.push(res.data.data);
          this.loadUsers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    editUser(user,callback=()=>{}) {
      console.debug("editing");
      console.debug(user);
      EasyPlanClient.User.Update(this.$route.params.companyAlias, user)
        .then((res) => {
          console.debug("risposta edit user:");
          console.debug(res);
          callback(res.data.data);
          this.loadUsers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    save() {
      if (this.editedIndex > -1) {
        
        this.editUser(this.editedUser,(user)=>{
          this.users=this.users.filter(u=>u.idUtente!=user.idUtente);
          this.users.push(user);
          this.close();
          let currentUser=SessionHelper.getCurrentUser();
          console.log("this.editedUser",user);
          console.log("currentUser",currentUser);
        if(this.editedUser.idUtente==user.idUtente){
          console.log("UTENTE CORRENTE",currentUser);
          currentUser.colore=user.colore;
          SessionHelper.setCurrentUser(currentUser);
          this.$emit("currentUserChaged",currentUser);
          // user.colore=value;
        }
        });
 
      } else {
        this.insertUser(this.editedUser);
      this.close();
      }

    },

    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadWorkers();
      this.loadRoles();
      this.loadUsers();
    },
    loadRoles() {
      console.log("loading roles....");
      EasyPlanClient.Role.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          console.debug("Roles",res.data.data);
          this.roles = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    loadUsers() {
      console.log("loading users...");
      EasyPlanClient.User.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          this.users = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>